import React from 'react';

export default function FormLabel({ children }) {
  return (
    <label
      className="block text-xs font-semibold mb-1.5 uppercase tracking-wide"
      style={{ color: '#6b7280' }}
    >
      {children}
    </label>
  );
}
